import { call, takeEvery, select } from 'redux-saga/effects';
import { getScribeById } from 'JS/sagas/selectors';
import { TRACK_OPEN_SCRIBE } from 'JS/actionCreators/trackingActions';
import { DELETE_SCRIBE, SORT_SCRIBES } from 'JS/actionCreators/scribeActions';

import { track } from '../mixpanelProvider';

function* trackOpenScribe({ scribeId }) {
  const scribe = yield select(state => getScribeById(state, scribeId));
  yield call(track, 'Open A Scribe', {
    'Scribe ID': scribeId,
    'Scribe Type': scribe.source?.type || 'unknown'
  });
}

function* trackSortScribes({ sortOrder }) {
  let sortType;
  switch (sortOrder) {
    case 'alphaDescend':
      sortType = 'Sort Z-A';
      break;
    case 'alphaAscend':
      sortType = 'Sort A-Z';
      break;
    case 'updatedDate':
      sortType = 'Sort Recently Used';
      break;
    default:
      sortType = sortOrder;
      break;
  }
  yield call(track, 'Sort My Scribes', { 'Sort Type': sortType });
}

function* trackDeleteScribe({ scribe }) {
  yield call(track, 'Delete Scribe', { 'Scribe ID': scribe.id, 'Scribe Type': scribe.source?.type || 'unknown' });
}

export default function* trackScribeListSagas() {
  yield takeEvery(TRACK_OPEN_SCRIBE, trackOpenScribe);
  yield takeEvery(SORT_SCRIBES, trackSortScribes);
  yield takeEvery(DELETE_SCRIBE, trackDeleteScribe);
}
